export default "__VITE_ASSET__CkiJzPv2__"